module.exports = __webpack_public_path__ + "img/MaskGroup2.07b23398.png";